import ArrowRight from '@img/icons/arrow-right.svg';
import Call from '@img/icons/call.svg';
import ChatBubble from '@img/icons/chat-bubble.svg';
import Check from '@img/icons/check.svg';
import ChevronDown from '@img/icons/chevron-down.svg';
import ChevronRight from '@img/icons/chevron-right.svg';
import Close from '@img/icons/close.svg';
import Facebook from '@img/icons/facebook.svg';
import HamburgerMenu from '@img/icons/hamburger-menu.svg';
import Instagram from '@img/icons/instagram.svg';
import PhoneInTalk from '@img/icons/phone-in-talk.svg';
import Search from '@img/icons/search.svg';
import Tick from '@img/icons/tick.svg';
import TrustpilotStarEmpty from '@img/icons/trustpilot-star-empty.svg';
import TrustpilotStarFilled from '@img/icons/trustpilot-star-filled.svg';
import XSocial from '@img/icons/x-social.svg';
import YouTube from '@img/icons/youtube.svg';
import React from 'react';
export var SystemIcon;
(function (SystemIcon) {
    SystemIcon["ArrowRight"] = "arrow-right";
    SystemIcon["Call"] = "call";
    SystemIcon["ChatBubble"] = "chat-bubble";
    SystemIcon["Check"] = "check";
    SystemIcon["ChevronDown"] = "chevron-down";
    SystemIcon["ChevronRight"] = "chevron-right";
    SystemIcon["Close"] = "close";
    SystemIcon["Facebook"] = "facebook";
    SystemIcon["HamburgerMenu"] = "hamburger-menu";
    SystemIcon["Instagram"] = "instagram";
    SystemIcon["PhoneInTalk"] = "phone-in-talk";
    SystemIcon["Search"] = "search";
    SystemIcon["Tick"] = "tick";
    SystemIcon["TrustpilotStarEmpty"] = "trustpilot-star-empty";
    SystemIcon["TrustpilotStarFilled"] = "trustpilot-star-filled";
    SystemIcon["YouTube"] = "youtube";
    SystemIcon["XSocial"] = "x-social";
})(SystemIcon || (SystemIcon = {}));
export function getSvgFromSystem(icons) {
    switch (icons) {
        case SystemIcon.ArrowRight: {
            return React.createElement(ArrowRight, null);
        }
        case SystemIcon.Call: {
            return React.createElement(Call, null);
        }
        case SystemIcon.ChatBubble: {
            return React.createElement(ChatBubble, null);
        }
        case SystemIcon.Check: {
            return React.createElement(Check, null);
        }
        case SystemIcon.ChevronDown: {
            return React.createElement(ChevronDown, null);
        }
        case SystemIcon.ChevronRight: {
            return React.createElement(ChevronRight, null);
        }
        case SystemIcon.Close: {
            return React.createElement(Close, null);
        }
        case SystemIcon.Facebook: {
            return React.createElement(Facebook, null);
        }
        case SystemIcon.HamburgerMenu: {
            return React.createElement(HamburgerMenu, null);
        }
        case SystemIcon.Instagram: {
            return React.createElement(Instagram, null);
        }
        case SystemIcon.PhoneInTalk: {
            return React.createElement(PhoneInTalk, null);
        }
        case SystemIcon.Search: {
            return React.createElement(Search, null);
        }
        case SystemIcon.Tick: {
            return React.createElement(Tick, null);
        }
        case SystemIcon.TrustpilotStarEmpty: {
            return React.createElement(TrustpilotStarEmpty, null);
        }
        case SystemIcon.TrustpilotStarFilled: {
            return React.createElement(TrustpilotStarFilled, null);
        }
        case SystemIcon.XSocial: {
            return React.createElement(XSocial, null);
        }
        case SystemIcon.YouTube: {
            return React.createElement(YouTube, null);
        }
        default: {
            return null;
        }
    }
}
